import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    background: ${(props) => props.theme.color[props.$mode === 'Light' ? 'g200' : 'p600']};
    padding: 105px 20px;

    .container-wrapper {
        display: flex;
    }
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL}
    ${(props) => props.theme.fontWeight.medium}

    color: ${(props) => props.theme.color.p500};
    margin-bottom: 40px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayM}
    }
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyS}
    line-height: 180%;

    color: ${(props) => props.theme.color.g600};

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.bodyL}
        line-height: 180%;
    }
`

export const Content = styled.div<{ withImage: boolean }>`
    background: ${(props) => props.theme.color.white};
    padding: 30px;
    border-radius: 10px;
    text-align: center;

    ${(props) =>
        props.withImage
            ? `
                @media ${props.theme.query.min.tablet} {
                    text-align: left;
                }
            `
            : ''}
`

export const Image = styled(ImageBase)`
    margin-left: 70px;
    display: none;

    @media ${(props) => props.theme.query.min.tablet} {
        display: block;
    }
`

export const Link = styled(LinkBase)`
    margin-top: 40px;
    display: inline-block;

    button {
        span:first-child {
            display: flex;
            align-items: center;
            line-height: initial;
            white-space: normal;
        }
    }
`
